import actions from '~/store/modules/shared/page/actions'
import getters from '~/store/modules/shared/page/getters'
import mutations from '~/store/modules/shared/page/mutations'
import state from '~/store/modules/shared/page/state'
import { createModule } from '~/factories/store'

export default createModule({
  actions,
  getters,
  mutations,
  state
})
